// Destino al que volver tras iniciar sesión.
//
// `from` viene de location.state, que ProtectedRoute rellena al mandar a
// /login. Aun así se valida: el estado de navegación puede fabricarse (o
// llegar de un enlace manipulado) y usarlo sin comprobar abriría una
// redirección a un dominio externo. Solo se aceptan rutas internas.
export const resolvePostLoginPath = (from, fallback) => {
  const pathname = from && typeof from === 'object' ? from.pathname : null;
  // '//host' y '/\host' los interpretan los navegadores como URL con host
  // (protocol-relative), así que no basta con exigir el '/' inicial.
  if (typeof pathname !== 'string' || !pathname.startsWith('/')
      || pathname.startsWith('//') || pathname.includes('\\')) {
    return fallback;
  }
  const search = typeof from.search === 'string' && from.search.startsWith('?') ? from.search : '';
  return pathname + search;
};
